import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {GRAY_DARKER} from 'ui-library/Colors';

export interface SelectedNumberProps {
  numSelected: number;
}

/**
 * A small text blurb that displays how many rows in the expanded search have been selected
 * by the user. When no rows are selected, nothing is displayed,
 */
export default function SelectedRowsCounter(props: SelectedNumberProps): JSX.Element | null {
  if (props.numSelected !== 0) {
    return (
      <div
        className={classNames(css(styles.pageDetails))}
        {...getTestProps({component: 'SelectedRowsCounter', element: 'root'})}
      >
        <span>
          {props.numSelected} {pluralize(props.numSelected, 'row')} selected
        </span>
      </div>
    );
  } else {
    return null;
  }
}

const styles = StyleSheet.create({
  pageDetails: {
    color: GRAY_DARKER,
    display: 'inline-block',
  },
});
